<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
          <h3 class="mb-5 mt-2">
            {{ $t('Users.Users') }}
          </h3>
            <CAlert
              :show.sync="dismissCountDown"
              color="primary"
              fade
            >
              ({{dismissCountDown}}) {{ message }}
            </CAlert>
            <CDataTable
              hover
              :items="items"
              :fields="fields"
              :items-per-page="100"
              pagination
              columnFilter
              tableFilter
              sorter
            >
              <template #marque="{item}">
                <td>
                  <strong>{{item.name}}</strong>
                </td>
              </template>
              <template #age="{item}">
                <td>
                  <span>{{item.age}}</span>
                </td>
              </template>
              <template #email="{item}">
                <td>
                  <span>{{item.email}}</span>
                </td>
              </template>
              <template #phone="{item}">
                <td>
                  <span>{{item.phone}}</span>
                </td>
              </template>
              <template #balance="{item}">
                <td>
                  <span class="badge badge-info" v-if="item.balance>0">{{item.balance}} <sup>DT</sup> </span>
                  <span class="badge badge-danger" v-else>{{item.balance}} <sup>DT</sup> </span>
                </td>
              </template>
              
              <template #add="{item}">
                <td>
                  <span>{{item.created_at}}</span>
                  <span>{{item.created_at_hours}}</span>
                </td>
              </template>
              
              <template #Options="{item}">
                <td class="text-right">
                  <CButton color="dark" @click="updateUserSub(item.id)" class="mr-2"><CIcon name="cil-center-focus" height="48"/> </CButton>
                  <CButton color="info" @click="manageModal(item)" class="mr-2"><CIcon name="cil-dollar" height="48"/> </CButton>
                  <CButton v-if="you!=item.id" color="danger" @click="deleteToast( item )"><CIcon name="cil-trash" height="48"/> </CButton>
                </td>
              </template>
            </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
    <vue-confirm-dialog></vue-confirm-dialog>
    <modal 
          :width="'300px'" 
          :maxWidth="200"
          :height="'auto'" 
          :name="'modal'"
          :styles="{
            zIndex: 99999
          }"
        >
          <div class="modal-div" style="padding: 20px 50px;max-height: 500px !important;overflow-x: hidden;">
            <div class="title" style="text-align: center;">
              Wallet du <b>{{selected.name}}</b>
            </div>
          
            <hr>
            <div style="text-align: center;">
              <span class="badge badge-info">{{selected.balance}}<sup>DT</sup></span>
            </div>
            <br>
            Ajouter/Retirer du solde
            <div class="row modal-size">
              <div class="col-6" style="float: left;margin-top: 5px;font-weight: bold;">
                <input type="text" placeholder="(+/-) Solde" v-model="toAdd.balance" style="height: 28px;padding: 0 5px;">
              </div>
              <div class="col-6" style="text-align: right">
                <CButton color="success" class="option-btn" @click="addToWallet(selected.id)"><CIcon name="cil-plus" height="48"/> </CButton>
              </div>
            </div>
          </div>
        </modal>
  </CRow>
</template>

<script>
import { userService } from '../../_services';
import moment from 'moment'

export default {
  name: 'Notes',
  data: () => {
    return {
      items: [],
      /*
      fields: [
        {key: 'author'},
        {key: 'title'},
        {key: 'content'},
        {key: 'applies_to_date'},
        {key: 'status'},
        {key: 'note_type'},
        {key: 'show'},
        {key: 'edit'},
        {key: 'delete'}
      ],
      */
      fields: [
        {key: 'name', label: 'Nom'},
        {key: 'age', label: 'Tranche d\'age'},
        {key: 'email', label: 'Email'},
        {key: 'phone', label: 'N° Tél'},
        {key: 'balance', label: 'Wallet'},
        {key: 'created_at', label: 'date d\'adhésion'},
        {key: 'Options', label: 'Options', sorter: false, filter: false},
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,

      selected: {
        name: ''
      },
      toAdd: {
        balance: null
      }
    }
  },
  computed: {
  },
  methods: {
    editUserSub(id) {
      return `users/${id.toString()}/updateUserSub`;
    },
    updateUserSub(id) {
      const editUserSub = this.editUserSub(id);
      this.$router.push({ path: editUserSub });
    },
    addToWallet(id){
      this.loader = this.$loading.show();
    
      userService.updateWallet({id: id, balance: this.toAdd.balance}).then(function(data){
        this.items = data.data.data.map((obj)=>{
            obj.created_at= moment(obj.created_at).format('DD MMMM YYYY')
            obj.created_at_hours= moment(obj.created_at).format('HH:mm')
            return obj
        });
        this.toAdd.balance= 0
        this.$toast.success('Wallet mis à jour avec succès !');
      }.bind(this)).finally(
          function () {
            this.loader.hide();
            this.$modal.hide('modal')
          }.bind(this)
      ).catch(function(){
        this.$toast.error('une erreur s\'est produite, veuillez vérifier le solde ajouté et réessayer !');
      });
    },
    manageModal(data){
      this.selected= data;
      this.$modal.show('modal')
    },
    getRowCount (items) {
      return items.length
    },
    noteLink (id) {
      return `notes/${id.toString()}`
    },
    editLink (id) {
      return `product/${id.toString()}/edit`
    },
    showNote ( id ) {
      const noteLink = this.noteLink( id );
      this.$router.push({path: noteLink});
    },
    editNote ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    deleteNote ( id ) {
      this.loader = this.$loading.show();
    
      userService.delete(id).then(function(data){
        this.items = data.data.data.map((obj)=>{
            obj.created_at= moment(obj.created_at).format('DD MMMM YYYY')
            obj.created_at_hours= moment(obj.created_at).format('HH:mm')
            return obj
        });
      }.bind(this)).finally(
          function () {
            this.loader.hide();
          }.bind(this)
      );
    },
    createProduct () {
      this.$router.push({path: 'users/create'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getProducts (){
      let self = this;
      this.loader = this.$loading.show();
      userService.getAll().then(function (response) {
        self.items = response.data.data.map((obj)=>{
            obj.created_at= moment(obj.created_at).format('DD MMMM YYYY')
            obj.updated_at= moment(obj.updated_at).format('DD MMMM YYYY')
            return obj
        });
      }).finally(function () {
        this.loader.hide();
      }.bind(this));
    },
    deleteToast(item){
      this.$confirm(
        {
          title: `Confirmation!`,
          message: 'êtes-vous sûr de supprimer l\'utilisateur \''+item.name+'\'?',
          button: {
            no: 'Annuler',
            yes: 'Supprimer'
          },
          /**
          * Callback Function
          * @param {Boolean} confirm 
          */
          callback: confirm => {
            if (confirm) {
              this.deleteNote(item.id)
            }
          }
        }
      )
    }
  },
  mounted: function(){
    this.getProducts();
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.badge{
  padding: 5px 10px;
}
</style>
